// Limpeza para remover dados antigos do localStorage - ficará online por 30 dias
localStorage.removeItem("operationToMatch");
localStorage.removeItem("selectedMatchId");

// The app lives in its own chunk so the browser paints the static hero from
// index.html before downloading and evaluating it.
let started = false;
const start = () => {
    if (started) return;
    started = true;
    import('./bootstrap');
};

// With the static hero on screen, wait for it to be painted (first contentful
// paint) before evaluating the app. Without it there is nothing to paint first.
if (!document.getElementById('boot-shell') || document.visibilityState === 'hidden' || !('PerformanceObserver' in window)) {
    start();
} else {
    try {
        const observer = new PerformanceObserver((list) => {
            if (list.getEntriesByName('first-contentful-paint').length) {
                observer.disconnect();
                setTimeout(start, 0);
            }
        });
        observer.observe({ type: 'paint', buffered: true });
    } catch {
        start();
    }
    setTimeout(start, 3000);
}
